import React, { useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import Create from "./Create";
import Edit from "./Edit";
import Categorias from "./Categorias";
import Login from "./Login";
import { CartContext } from "../context/CartContext";

const Show = ({ isAdmin, setIsAdmin }) => {
  // Extraemos itemsAdmin para ver TODO y loadProducts para refrescar
  const { itemsAdmin, isLoading, loadProducts } = useContext(CartContext);
  const [searchTerm, setSearchTerm] = useState("");
  const [viewActive, setViewActive] = useState(true);
  const navigate = useNavigate();

  if (!isAdmin) {
    return <Login onLoginSuccess={() => setIsAdmin(true)} />;
  }

  const handleLogout = () => {
    setIsAdmin(false);
    localStorage.removeItem("adminLogueado");
    navigate("/");
  };

  const deleteProduct = async (id) => {
    const result = await Swal.fire({
      title: "¿Estás seguro?",
      text: "El producto y sus imágenes se eliminarán permanentemente.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      confirmButtonText: "Sí, borrar",
      cancelButtonText: "Cancelar",
    });

    if (result.isConfirmed) {
      try {
        const resp = await fetch(
          "https://espacioanalogico.com.ar/api/delete_product.php",
          {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ id }),
            credentials: "include",
          },
        );

        const res = await resp.json();

        if (res.success) {
          if (loadProducts) {
            await loadProducts();
          }

          Swal.fire({
            title: "Eliminado",
            text: "El producto se borró y la lista se actualizó.",
            icon: "success",
            timer: 1500,
            showConfirmButton: false,
          });
        } else {
          Swal.fire("Error", res.message || "No autorizado", "error");
        }
      } catch (error) {
        console.error("Error al borrar:", error);
        Swal.fire("Error", "No se pudo conectar con el servidor", "error");
      }
    }
  };

  // FILTRADO SOBRE LA LISTA DE ADMIN
  const filteredProducts = itemsAdmin.filter((p) => {
    const matchesSearch =
      (p.titulo?.toLowerCase() || "").includes(searchTerm.toLowerCase()) ||
      (p.categoria?.toLowerCase() || "").includes(searchTerm.toLowerCase());

    const isPausado = p.estado?.toLowerCase() === "pausado";
    const matchesTab = viewActive ? !isPausado : isPausado;

    return matchesSearch && matchesTab;
  });

  if (isLoading)
    return <div className="text-center mt-5">Cargando Administrador...</div>;

  return (
    <div className="container mt-4 pb-5">
      {/* HEADER */}
      <div className="d-flex flex-column flex-md-row justify-content-between align-items-center mb-4 bg-white p-3 rounded shadow-sm border gap-3">
        <div className="d-flex align-items-center gap-2">
          <h2 className="h4 mb-0 text-dark me-3">Admin Espacio</h2>
          <Categorias />
          <Create />
        </div>

        <div className="input-group" style={{ maxWidth: "350px" }}>
          <span className="input-group-text bg-white border-end-0">
            <i className="bi bi-search text-muted"></i>
          </span>
          <input
            type="text"
            className="form-control border-start-0"
            placeholder="Buscar..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </div>

        <button onClick={handleLogout} className="btn btn-outline-danger">
          <i className="bi bi-box-arrow-right me-2"></i>Salir
        </button>
      </div>

      {/* TABS (Calculados sobre itemsAdmin) */}
      <ul className="nav nav-tabs mb-3">
        <li
          className="nav-item"
          style={{ cursor: "pointer" }}
          onClick={() => setViewActive(true)}
        >
          <span
            className={`nav-link ${viewActive ? "active fw-bold text-primary" : "text-muted"}`}
          >
            Activos (
            {
              itemsAdmin.filter((p) => p.estado?.toLowerCase() !== "pausado")
                .length
            }
            )
          </span>
        </li>
        <li
          className="nav-item"
          style={{ cursor: "pointer" }}
          onClick={() => setViewActive(false)}
        >
          <span
            className={`nav-link ${!viewActive ? "active fw-bold text-danger" : "text-muted"}`}
          >
            Pausados (
            {
              itemsAdmin.filter((p) => p.estado?.toLowerCase() === "pausado")
                .length
            }
            )
          </span>
        </li>
      </ul>

      {/* TABLA */}
      <div className="table-responsive shadow-sm rounded border bg-white">
        <table className="table table-hover mb-0">
          <thead className="table-secondary">
            <tr>
              <th style={{ width: "80px" }}>Imagen</th>
              <th>Título</th>
              <th>Categoría</th>
              <th>Precio</th>
              <th>Stock</th>
              <th className="text-center">Acciones</th>
            </tr>
          </thead>
          <tbody>
            {filteredProducts.map((product) => {
              let imagesArray = [];
              try {
                imagesArray =
                  typeof product.imagenes === "string"
                    ? JSON.parse(product.imagenes)
                    : product.imagenes;
              } catch (e) {
                imagesArray = [];
              }

              const firstImage =
                imagesArray?.length > 0 ? imagesArray[0].url : null;

              return (
                <tr key={product.id} className="align-middle">
                  <td>
                    <div
                      style={{ width: "55px", height: "55px" }}
                      className="rounded border bg-light d-flex align-items-center justify-content-center overflow-hidden"
                    >
                      {firstImage ? (
                        <img
                          src={firstImage}
                          alt=""
                          style={{
                            width: "100%",
                            height: "100%",
                            objectFit: "cover",
                          }}
                        />
                      ) : (
                        <i className="bi bi-image text-muted"></i>
                      )}
                    </div>
                  </td>
                  <td className="fw-bold">{product.titulo}</td>
                  <td>
                    <span className="badge bg-light text-dark border">
                      {product.categoria}
                    </span>
                  </td>
                  <td className="text-success fw-bold">
                    ${Number(product.precio || 0).toLocaleString("es-AR")}
                  </td>
                  <td>{product.stock} un.</td>
                  <td>
                    <div className="d-flex justify-content-center gap-3 align-items-center">
                      <Edit productData={product} />
                      <button
                        onClick={() => deleteProduct(product.id)}
                        className="btn btn-link text-danger p-0 border-0"
                      >
                        <i className="bi bi-trash fs-5"></i>
                      </button>
                    </div>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default Show;
